// @flow

import React, { type Node, useCallback, useEffect } from 'react';
import styled from 'styled-components';
import { Separator } from '@tectonics/look-and-feel/volcanes/atoms';
import { usePendingIncomingPayment } from '@tectonics/prs/incoming-payment';
import { getUpiIntentAppLinksInPendingPayment } from '@tectonics/prs/incoming-payment/get-upi-intent';
import { getAppImageSrc, getAppName, getRedirectAppLink } from './get-app';

export function UpiIntentPage(): Node {
  const incomingPayment = usePendingIncomingPayment();
  const appLinks = getUpiIntentAppLinksInPendingPayment(incomingPayment);
  let firstAppLinkArray = appLinks[0].split('://upi');
  if(firstAppLinkArray.length === 1) {
    firstAppLinkArray = appLinks[0].split('://');
    firstAppLinkArray[1] = '://' + firstAppLinkArray[1];
  }
  const linkOtherApp = `upi:${firstAppLinkArray[1]}`;
  const nameOtherApp = 'Choose other UPI APP';

  const linkStyle = {
    textDecoration: 'none',
    cursor: 'pointer',
    color: '#121419',
  };

  const handleClick = useCallback((appName) => {
    sessionStorage.setItem('appName', appName);
    getRedirectAppLink(appLinks, linkOtherApp);
  });

  useEffect(() => {
    getRedirectAppLink(appLinks, linkOtherApp);
  });

  return (
    <Root>
      <Body>
        <Title>Please, select your UPI APP:</Title>
        <Separator direction="horizontal" size={7} />
        <Apps>
          {appLinks.map((link, index) => {
            return (
              <img
                key={index}
                style={linkStyle}
                src={getAppImageSrc(link)}
                alt={getAppName(link)}
                onClick={() => handleClick(getAppName(link))}
              />
            );
          })}
        </Apps>
        <Separator direction="vertical" size={4} />

        <InfoBody>
          <Info>
            <span
              style={linkStyle}
              name={nameOtherApp}
              onClick={() => handleClick('other-app')}
            >
              {nameOtherApp}
            </span>
          </Info>
        </InfoBody>
        <Separator direction="vertical" size={3} />
        <SubTitle>Processing may take a few minutes. Please do not refresh or use the back button to avoid transaction issues</SubTitle>
      </Body>
    </Root>
  );
}

const Root = styled.div`
  color: ${props => props.theme.colors.gray(20)};
`;

const Body = styled.div`
  padding: 32px 0;
`;

const Title = styled.h1`
  text-align: center;
  width: Fixed (342px);
  height: Hug (21px);
`;

const SubTitle = styled.h1`
  text-align: center;
  width: Fixed (200px);
  height: Hug (10px);
`;

const Apps = styled.div`
  display: flex;
  justify-content: space-evenly;
`;

const InfoBody = styled.div`
  background: ${props => props.theme.colors.new_primary[50]};
  border-radius: 4px;
  display: flex;
  align-items: center;
  padding: 8px;
`;

const Info = styled.div`
  text-align: center;
  font-size: 13px;
  line-height: 21px;
  color: ${props => props.theme.colors.neutral[900]};
  width: 100%;
  display: inline-block;
  font-family: Noto Sans, "Open Sans", "OpenSans", Arial, "Helvetica Neue", Helvetica, sans-serif;
`;
